<bootstrap-popup [id]="'editGroupementParcDialog'" [title]="title">
	<form role="form" class="form-horizontal" >
		<div *ngIf="groupementParc" class="form-group">
			<label for="code" class="col-md-1 control-label">Code*</label>
			<div class="col-md-3">
				<input id="code" name="code" [(ngModel)]="groupementParc.code" 
					[ngClass]="groupementParc.code ? 'form-control' : 'form-control error'" />
			</div>
			<label for="libelle" class="col-md-1 plus-half control-label">Libellé*</label>
			<div class="col-md-4 plus-half">
				<input id="libelle" name="libelle" [(ngModel)]="groupementParc.libelle" 
					[ngClass]="groupementParc.libelle ? 'form-control' : 'form-control error'"/>
			</div>
		</div>
		<div *ngIf="groupementParc" class="form-group">
			<label for="code" class="col-md-1 control-label">Antenne*</label>
			<div class="col-md-3 ">
				<filterable-select
	                [id]="'antenne'"
	                [inputClass]="!selectedAntenne ? 'form-control error' : 'form-control'"
	                [list]="antennes"
	                [labelGetter]="getAntenneLabel"
	                [(selectedItem)]="selectedAntenne"
	                (selectedItemChange)="onAntenneChange($event)"
                  >
                  </filterable-select>
			</div>
		</div>
		<div *ngIf="groupementParc" class="form-group">
			<label for="code" class="col-md-1 control-label">Parcs*</label>
			<div class="col-md-11 parc-selector" #container>
	            <filtered-drag-drop-groups
	                    [parentContainer] = "container"
	                    [containerClass] = "'col-sm-5'"
	                    [listClass] = "parcsChoisis.length && allChosenParcsHaveSameResponsable && allChosenParcsHaveSameEnergie  ? 'form-control' : 'form-control error'"
	                    [leftTitle] = "'Parcs disponibles'" [leftList] = "parcsDispos"
	                    [rightTitle] = "'Parcs Choisis'" [rightList] = "parcsChoisis"
	                    [labelGetter] = "getParcLabel"
	                    (changesOccured) = "changesOccuredInParcs()"
	                    >
	            </filtered-drag-drop-groups>
			</div>
		</div>
		
		<div class="form-group">
			<div class="col-md-12 text-center">
				<button type="button" class="btn btn-default" style="margin-right: 6px" (click)="onCancelRequested()" >
					Annuler
				</button>
				<button *ngIf="mode === modes.CREATION" type="button" class="btn btn-success" title="{{ getErrorHelp() }}" 
					(click)="onCreate()" [disabled]="!groupementParc.code || !groupementParc.libelle || !parcsChoisis.length || !allChosenParcsHaveSameResponsable" >
					Créer
				</button>
				<button *ngIf="mode === modes.UPDATE" type="button" class="btn btn-success" title="{{ getErrorHelp() }}" 
					(click)="onModify()" [disabled]="!groupementParc.code || !groupementParc.libelle || !parcsChoisis.length || !allChosenParcsHaveSameResponsable" >
					Enregistrer
				</button>
			</div>
		</div>
	</form>
</bootstrap-popup>